import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const businessCategoryImporterSelectors = importerSelectors(
  'businessCategory.importer',
)

export default businessCategoryImporterSelectors
